import type { JSX } from "react";

import { Trans } from "@lingui/react";
import { Loader } from "@mobsuccess-devops/react-ui/Loader";

export function PendingPage(): JSX.Element {
  return (
    <Loader.Block>
      <Loader.Ellipsis />
      <Loader.Description>
        <Trans id="pending-page.loading-user-infos" />
      </Loader.Description>
    </Loader.Block>
  );
}
